import { get } from "lodash";

function makeLens(technicalDefault) {
    return {
        getValue(obj, path, logicalDefault) {
            const defaultValue = logicalDefault !== undefined ? logicalDefault : technicalDefault
            return get(obj, path, defaultValue) ?? technicalDefault;
        }
    };
}

export const arrayLens = makeLens([]);

export const stringLens = makeLens('');
